module.exports = __webpack_public_path__ + "static/media/ico-whats.bff2558c.svg";